var _circle, _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 61,
    viewBox: "0 0 130 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.0002,
    cy: 46.5359,
    r: 14,
    fill: "#E4E4D3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_223_919)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5044 16.5702L40.5001 0.401925C39.5719 -0.133974 38.4283 -0.133975 37.5001 0.401923L1.5 21.1866C0.571793 21.7225 -4.68748e-06 22.7129 0 23.7847L7.23976e-05 50.5359H4.00007V26.094C4.00007 25.0222 4.57187 24.0318 5.50007 23.4959L37.5001 5.02072C38.4283 4.48483 39.5719 4.48483 40.5001 5.02073L66.7708 20.1881L68.5044 16.5702Z",
    fill: "#B87E58"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3945 45.8455H66.8389L63.3115 53.5359H58.1641L73.832 19.8826L88.9463 53.5359H83.7168L80.3945 45.8455ZM78.4463 41.3542L73.75 30.5876L68.8281 41.3542H78.4463Z",
    fill: "#273F39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6572 33.5613V53.5359H92.043V33.5613H96.6572ZM91.3457 25.2556C91.3457 24.449 91.6396 23.7517 92.2275 23.1638C92.8154 22.5759 93.5195 22.282 94.3398 22.282C95.1738 22.282 95.8848 22.5759 96.4727 23.1638C97.0605 23.738 97.3545 24.4421 97.3545 25.2761C97.3545 26.1101 97.0605 26.821 96.4727 27.4089C95.8984 27.9968 95.1943 28.2908 94.3604 28.2908C93.5264 28.2908 92.8154 27.9968 92.2275 27.4089C91.6396 26.821 91.3457 26.1033 91.3457 25.2556Z",
    fill: "#273F39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.502 33.5613H107.116V35.407C108.005 34.4773 108.764 33.8484 109.393 33.5203C110.062 33.1785 110.903 33.0076 111.915 33.0076C114.171 33.0076 115.955 33.9919 117.268 35.9607C118.717 33.9919 120.679 33.0076 123.153 33.0076C127.651 33.0076 129.9 35.7351 129.9 41.1902V53.5359H125.266V42.4412C125.266 40.5271 125.033 39.1736 124.568 38.3806C124.09 37.574 123.304 37.1707 122.21 37.1707C120.938 37.1707 120.009 37.6492 119.421 38.6062C118.847 39.5632 118.56 41.1013 118.56 43.2205V53.5359H113.925V42.5027C113.925 38.948 112.899 37.1707 110.849 37.1707C109.55 37.1707 108.6 37.656 107.998 38.6267C107.41 39.5974 107.116 41.1287 107.116 43.2205V53.5359H102.502V33.5613Z",
    fill: "#273F39"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_223_919",
    x: -4,
    y: -4,
    width: 76.5044,
    height: 58.5359,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_223_919"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_223_919",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.03adfa78ba8f48f2607e3f1e12cc0e36.svg";
export { ForwardRef as ReactComponent };